import React from "react"
import { Drawer as DrawerPrimitive } from "@base-ui/react/drawer"
import { VisuallyHidden } from "../visually-hidden"

export type DrawerTriggerProps = {
  accessibleName?: string
  children?: React.ReactNode
  disabled?: boolean
  render?: React.ReactElement
}

export function DrawerTrigger({
  accessibleName,
  children,
  disabled,
  render
}: DrawerTriggerProps) {
  return (
    <DrawerPrimitive.Trigger
      data-slot="drawer-trigger"
      disabled={disabled}
      render={render}
    >
      {accessibleName && <VisuallyHidden>{accessibleName}</VisuallyHidden>}
      {children}
    </DrawerPrimitive.Trigger>
  )
}

DrawerTrigger.displayName = "Drawer.Trigger"
